module.exports = __webpack_public_path__ + "static/media/laugh.ff9ac511.svg";